/* src/app/forms/wizard-configuracao/multiple-context/multiple-context.component.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 10px;
  margin: 10px;
}
.multi-context-main {
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
  gap: 4px;
}
.multi-context-edit {
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 5px;
}
.cfg-text {
  width: 100%;
  text-align: end;
}
.bar-main-context {
  gap: 6px;
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
}
.cfg-main {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
}
.more-options {
  padding-top: 4px;
  padding-bottom: 4px;
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 20px;
  align-items: center;
  padding-right: 10px;
  padding-left: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
}
.info {
  border-radius: 16px;
  padding: 15px;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.24), 0 0 2px rgba(0, 0, 0, 0.12);
  background-color: #FFFFE1;
  text-align: center;
}
.title-panel {
  width: 100%;
  font-size: large;
  font-weight: 500;
  margin-bottom: 6px;
}
.spacer {
  width: 100%;
}
/*# sourceMappingURL=multiple-context.component.css.map */
